import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=12a332b7&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "./Balance.vue?vue&type=style&index=0&id=12a332b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a332b7",
  null
  
)

export default component.exports